import { useState, useEffect } from 'react'
import { NewsFilter, NewsItem } from '../types'
import NewsCard from './NewsCard'
import { API_BASE_URL } from '../config/sources'

interface Props {
  filter: NewsFilter
}

export default function NewsList({ filter }: Props) {
  const [news, setNews] = useState<NewsItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    fetchNews()
  }, [filter])

  const fetchNews = async () => {
    try {
      setLoading(true)
      setError(null)

      const params = new URLSearchParams()
      if (filter.games.length > 0 && !filter.games.includes('all')) {
        params.append('games', filter.games.join(','))
      }
      if (filter.sources.length > 0) {
        params.append('sources', filter.sources.join(','))
      }
      if (filter.keyword) {
        params.append('keyword', filter.keyword)
      }

      const url = `${API_BASE_URL}/news${params.toString() ? `?${params.toString()}` : ''}`
      const response = await fetch(url)
      
      if (!response.ok) {
        throw new Error('获取新闻失败')
      }

      const data = await response.json()
      setNews(data.data || [])
    } catch (err) {
      setError(err instanceof Error ? err.message : '未知错误')
      setNews([])
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="loading-spinner"></div>
      </div>
    )
  }

  if (error && news.length === 0) {
    return (
      <div className="text-center py-20">
        <div className="text-6xl mb-4">😢</div>
        <p className="text-white text-lg">{error}</p>
        <button
          onClick={fetchNews}
          className="mt-4 px-6 py-2 bg-white text-purple-900 rounded-lg font-medium hover:bg-white/90 transition-colors"
        >
          重试
        </button>
      </div>
    )
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-white">
          最新资讯
          {filter.keyword && (
            <span className="text-white/60 text-base font-normal ml-2">
              - 搜索: "{filter.keyword}"
            </span>
          )}
        </h2>
        <span className="text-white/60 text-sm">
          共 {news.length} 条
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {news.map(item => (
          <NewsCard key={item.id} item={item} />
        ))}
      </div>

      {news.length === 0 && (
        <div className="text-center py-20">
          <div className="text-6xl mb-4">📭</div>
          <p className="text-white text-lg">暂无相关资讯</p>
        </div>
      )}
    </div>
  )
}
